// contain list of routes
const routes = [
  {
    title: "Dashboard",
    path: "/dashboard",
    icon: "fas fa-tachometer-alt",
  },
 
  {
    title: "Agent Management",
    path: "/dashboard/agent",

    icon: "fas fa-user",
  },
  {
    title: "Rates Module",
    path: "/dashboard/Rates",
    icon: "fas fa-file-alt",
  },
  {
    title: "Agent Invoice",
    path: "/dashboard/agentinvoice",
    icon: "fas fa-file-invoice-dollar",
  },
  {
    title: "list Agent Invoice",
    path: "/dashboard/listagentinvoice",
    icon: "fas fa-file-invoice-dollar",
  },
  {
    title: "Promotional Messages",
    path: "/dashboard/PromotionalMessages",
    icon: "fas fa-file-invoice-dollar",
  },
  {
    title: "FCM Messages",
    path: "/dashboard/FCMMessages",
    icon: "fas fa-file-invoice-dollar",
  },
  {
    title: "Logs",
    path: "/dashboard/logs",
    icon: "fas fa-bars",
  }
];

export default routes;
